import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Configuracion from "../../../data/configuracion";
import DynamicIcon from "../../../components/DynamicIcon";
import ModalPermisosrol from "../../../components/ModalPermisosrol"; // Ajusta si está en otra ruta


export default function FormRoles({ autusuario }) {
  const [rolesdata, setRolesData] = useState([]);
  const [errores, setErrores] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [nuevoRol, setNuevoRol] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [guardando, setGuardando] = useState(false);
  const rolesPorPagina = 10;
  const [busqueda, setBusqueda] = useState("");
  const [rolAEliminar, setRolAEliminar] = useState(null);
  const [showEliminarModal, setShowEliminarModal] = useState(false);
  const [rolEditando, setRolEditando] = useState(null);
  const [sortColumn, setSortColumn] = useState("NombreRol");
  const [sortDirection, setSortDirection] = useState("asc");

    // NUEVOS ESTADOS PARA MODAL DE PERMISOS
  const [showPermisosModal, setShowPermisosModal] = useState(false);
  const [permisosDelRol, setPermisosDelRol] = useState([]);

  useEffect(() => {
    cargarRoles();
  }, []);

  const cargarRoles = () => {
    if (
      !autusuario ||
      !autusuario.configuracion ||
      !autusuario.configuracion.proyecto ||
      !autusuario.email ||
      !autusuario.configuracion.basedatos
    ) {
      setErrores("Faltan datos del usuario para cargar roles");
      return;
    }

    axios
      .post(`${Configuracion.urlapi}/api/roles/getroles`, {
        appid: autusuario.configuracion.proyecto,
        email: autusuario.email,
        basedatos: autusuario.configuracion.basedatos,
      })
      .then((response) => {
        const datos = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data[0])
          ? response.data[0]
          : [];

        if (Array.isArray(datos)) {
          setRolesData(datos);
          setErrores(null);
        } else {
          setErrores("Respuesta inesperada del servidor");
          setRolesData([]);
        }
      })
      .catch(() => {
        setErrores("Error al cargar roles");
        setRolesData([]);
      });
  };

  const handleEditar = (id) => {
    const rol = rolesdata.find((item) => item.Id === id);
    if (rol) {
      setRolEditando(rol);
      setNuevoRol(rol.NombreRol);
      setMensaje("");
      setShowModal(true);
    }
  };
  const handlePermisos = (item) => {
   setPermisosDelRol(item.Permisos || []);
  setShowPermisosModal(true);
   
  };

  const handleEliminar = (id) => {
    const rol = rolesdata.find((item) => item.Id === id);
    if (rol) {
      setRolAEliminar(rol);
      setShowEliminarModal(true);
    }
  };

  const confirmarEliminar = async () => {

   if (!rolAEliminar) return;
    try {
      // Asumiendo que hay un endpoint para eliminar rol


  await axios.post(`${Configuracion.urlapi}/api/roles/deleterol`, {
  appid: autusuario.configuracion.proyecto,
  basedatos: autusuario.configuracion.basedatos,
  rol_id: rolAEliminar.Id, 
});   
      cargarRoles();
      setShowEliminarModal(false);
      setRolAEliminar(null);
      
    } catch (error) {      
      setMensaje("Error eliminando el rol.");
    }
  };

  const handleNuevoRol = () => {
    setNuevoRol("");
    setMensaje("");
    setRolEditando(null);
    setShowModal(true);
  };

  const handleGuardarRol = async () => {
    const nombreTrimmed = nuevoRol.trim();

    if (!nombreTrimmed) {
      setMensaje("El nombre del rol es obligatorio.");
      return;
    }

    const existe = rolesdata.some(
      (item) =>
        item.NombreRol.toLowerCase() === nombreTrimmed.toLowerCase() &&
        (!rolEditando || item.Id !== rolEditando.Id)
    );

    if (existe) {
      setMensaje("Ya existe un rol con ese nombre.");
      return;
    }

    if (
      !autusuario ||
      !autusuario.configuracion ||
      !autusuario.configuracion.proyecto ||
      !autusuario.email ||
      !autusuario.configuracion.basedatos
    ) {
      setMensaje("Faltan datos del usuario para guardar el rol.");
      return;
    }

    const payload = {
      appid: autusuario.configuracion.proyecto,
      basedatos: autusuario.configuracion.basedatos,
      nombrerol: nombreTrimmed,
    };

    if (rolEditando) {
      payload.numid = rolEditando.Id;
    }

    setGuardando(true);

    try {
      const endpoint = rolEditando
        ? `${Configuracion.urlapi}/api/roles/updaterol`
        : `${Configuracion.urlapi}/api/roles/addrol`;

      const response = await axios.post(endpoint, payload);

      if (response.data?.Resultado?.includes("duplicado")) {
        setMensaje("Ya existe un rol con ese nombre.");
        return;
      }

      setShowModal(false);
      cargarRoles();
      setRolEditando(null);
      setNuevoRol("");
      setMensaje("");
    } catch (error) {
      console.error("Error al guardar rol:", error);
      setMensaje("Error al guardar el rol.");
    } finally {
      setGuardando(false);
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
    setPaginaActual(1);
  };

  const filteredAndSortedRoles = Array.isArray(rolesdata)
    ? [...rolesdata]
        .filter((item) =>
          item.NombreRol.toLowerCase().includes(busqueda.toLowerCase())
        )
        .sort((a, b) => {
          const aValue = a[sortColumn];
          const bValue = b[sortColumn];
          if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
          if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
          return 0;
        })
    : [];

  const totalPaginas = Math.ceil(filteredAndSortedRoles.length / rolesPorPagina);
  const rolesPaginadas = filteredAndSortedRoles.slice(
    (paginaActual - 1) * rolesPorPagina,
    paginaActual * rolesPorPagina
  );

  return (
    <div className="w-full mx-auto p-2 bg-white shadow-lg h-[90vh] overflow-y-auto">
      <h2 className="hidden text-2xl font-bold mb-2">Lista de Roles</h2>

      <div className="flex flex-wrap justify-center items-center mb-4 gap-2">
        <div className="flex space-x-2">
          <input
            type="text"
            value={busqueda}
            onChange={(e) => {
              setBusqueda(e.target.value);
              setPaginaActual(1);
            }}
            placeholder="Buscar Rol..."
            className="hidden border border-gray-300 rounded px-3 py-2 w-64"
          />

          <button
            onClick={handleNuevoRol}
            className="flex items-center space-x-1 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded"
          >
            <span>Agregar Rol</span>
          </button>

          <button
            onClick={() => {
              const dataExport = rolesdata.map((item) => ({
                Id: item.Id,
                NombreRol: item.NombreRol,
              }));
              const worksheet = XLSX.utils.json_to_sheet(dataExport);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Roles");
              const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
              });
              const blob = new Blob([excelBuffer], {
                type: "application/octet-stream",
              });
              saveAs(blob, "roles.xlsx");
            }}
            className="hidden flex items-center space-x-1 bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded"
          >
            <FaFileExcel />
            <span>Exportar Excel</span>
          </button>
        </div>
      </div>

      {errores && <p className="text-red-600">{errores}</p>}

      <table className="min-w-full table-auto">
        <thead className="bg-sidebar-200 text-white sticky top-0 z-10">
          <tr>
            <th
              className="px-2 text-left cursor-pointer"
              onClick={() => handleSort("NombreRol")}
            >
              Rol
              {sortColumn === "NombreRol" && (
                <span className="ml-1">
                  {sortDirection === "asc" ? " ▲" : " ▼"}
                </span>
              )}
            </th>
            <th className="px-2 text-left">Acción</th>
          </tr>
        </thead>
        <tbody>
          {rolesPaginadas.map((item, index) => (
            <tr
              key={index}
              className={
                index % 2 === 0
                  ? "bg-white hover:bg-gray-300"
                  : "bg-gray-100 hover:bg-gray-300"
              }
            >
              <td className="px-2">{item.NombreRol}</td>
              <td className="px-2">
                <div className="flex justify-center space-x-2">
                  <button
                    onClick={() => handleEditar(item.Id)}
                    className="text-green-800 hover:underline"
                    title="Editar"
                  >
                    <DynamicIcon iconName="edit" size="1em" />
                  </button>
                  <button
                    onClick={() => handlePermisos(item)}
                    className="text-blue-600 hover:underline"
                    title="Permisos"
                  >
                    <DynamicIcon iconName="permisos" size="1em" />
                  </button>
                  <button
                    onClick={() => handleEliminar(item.Id)}
                    className="text-red-800 hover:underline"
                    title="Eliminar"
                  >
                    <DynamicIcon iconName="delete" size="1em" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-center items-center space-x-2 mt-4">
        <button
          onClick={() => setPaginaActual((prev) => Math.max(prev - 1, 1))}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          disabled={paginaActual === 1}
        >
          Anterior
        </button>

        {[...Array(totalPaginas)].map((_, index) => (
          <button
            key={index}
            onClick={() => setPaginaActual(index + 1)}
            className={`px-3 py-1 rounded ${
              paginaActual === index + 1
                ? "bg-blue-500 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {index + 1}
          </button>
        ))}

        <button
          onClick={() =>
            setPaginaActual((prev) => Math.min(prev + 1, totalPaginas))
          }
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          disabled={paginaActual === totalPaginas}
        >
          Siguiente
        </button>
      </div>

      {/* Modal para nuevo/editar rol */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
            <div className="bg-sidebar-200 rounded-t-md text-white pl-4 pt-1 font-bold h-[2rem]">
              {rolEditando ? "Editar Rol" : "Nuevo Rol"}
            </div>

            <label className="block mb-1 font-semibold mx-4 mt-2">
              Nombre de rol:
            </label>
            <input
              type="text"
              value={nuevoRol}
              onChange={(e) => setNuevoRol(e.target.value)}
              className="w-[90%] border border-gray-300 mx-4 px-4 py-2 rounded mb-2"
              placeholder="Nombre del rol"
            />

            {mensaje && <p className="text-red-600 mb-2 mx-4">{mensaje}</p>}
            {guardando && (
              <p className="text-blue-600 font-medium mb-2 mx-4">Guardando...</p>
            )}

            <div className="flex justify-end space-x-2 px-4">
              <button
                onClick={() => {
                  setShowModal(false);
                  setRolEditando(null);
                  setMensaje("");
                }}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 mb-4 px-4 py-2 rounded"
              >
                Cancelar
              </button>
              <button
                onClick={handleGuardarRol}
                disabled={guardando}
                className="bg-green-600 hover:bg-green-700 text-white px-4 mb-4 mr-4 py-2 rounded"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

{/* Modal de confirmación para eliminar */}
{showEliminarModal && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-titulo"
  >
    <div className="bg-white p-6 rounded-lg shadow-xl text-center w-[90%] max-w-md">
      <h2 id="modal-titulo" className="text-xl font-semibold mb-4">
        Confirmar eliminación
      </h2>
      <p className="mb-6">
        ¿Estás seguro de que deseas eliminar el rol{" "}
        <strong>{rolAEliminar?.NombreRol}</strong>?
      </p>
      <div className="flex justify-center gap-4">
        <button
          type="button"
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          onClick={confirmarEliminar}
        >
          Sí, eliminar
        </button>
        <button
          type="button"
          className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400"
          onClick={() => setShowEliminarModal(false)}
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
)}
<ModalPermisosrol
  isOpen={showPermisosModal}
  onClose={() => setShowPermisosModal(false)}
  selectedPermisos={permisosDelRol}
  onSave={() => {
    setShowPermisosModal(false);
    cargarRoles(); // Recargar roles al guardar
  }}
/>

    </div>
  );
}
